(() => {
  function init(row) {
    if (row.dataset.lopThumbnailReady) return;
    row.dataset.lopThumbnailReady = 'true';

    const rail = row.querySelector('[data-product-gallery-thumbnails]');
    const previous = row.querySelector('[data-lop-thumbnail-previous]');
    const next = row.querySelector('[data-lop-thumbnail-next]');
    const gallery = row.closest('[data-product-gallery-wrapper]')?.querySelector('[data-product-gallery]');
    if (!rail || !previous || !next) return;

    const cells = () => Array.from(rail.querySelectorAll('.gallery-cell'));
    const updateArrows = () => {
      const limit = rail.scrollWidth - rail.clientWidth;
      const overflow = limit > 2;
      previous.hidden = !overflow;
      next.hidden = !overflow;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= limit - 2;
    };
    const reveal = (cell) => {
      if (!cell) return;
      const viewport = rail.getBoundingClientRect();
      const bounds = cell.getBoundingClientRect();
      if (bounds.left < viewport.left) {
        rail.scrollBy({ left: bounds.left - viewport.left, behavior: 'smooth' });
      } else if (bounds.right > viewport.right) {
        rail.scrollBy({ left: bounds.right - viewport.right, behavior: 'smooth' });
      }
    };
    const select = (index) => {
      const thumbnails = cells();
      thumbnails.forEach((cell, cellIndex) => {
        cell.classList.toggle('is-nav-selected', cellIndex === index);
      });
      reveal(thumbnails[index]);
    };
    const scroll = (direction) => {
      const first = cells()[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    rail.addEventListener('scroll', updateArrows, { passive: true });
    rail.addEventListener('click', (event) => {
      const cell = event.target.closest('.gallery-cell');
      if (cell && rail.contains(cell)) select(cells().indexOf(cell));
    });
    if (gallery && window.jQuery) {
      window.jQuery(gallery).on('select.flickity', (_event, index) => select(index));
      select(window.jQuery(gallery).data('flickity')?.selectedIndex || 0);
    }
    if (window.ResizeObserver) new ResizeObserver(updateArrows).observe(rail);
    if (window.MutationObserver) new MutationObserver(updateArrows).observe(rail, { childList: true });
    window.addEventListener('load', updateArrows, { once: true });
    updateArrows();
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-lop-thumbnail-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
